<rl-menu [actions]="['edit', 'delete']" (onClick)="this[$event]()"></rl-menu>